import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { SubjectFormValues } from 'src/models/Subject.model';

type Props = {
    formikProps: FormikProps<SubjectFormValues>;
    onClose: () => void;
    formType: "ADD" | "EDIT";
};

const SubjectForm = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>
                    {formType === "ADD" ? "Add Subject" : "Update Subject"}{" "}
                </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='subjectName'
                        value={values.subjectName}
                        required
                        onChange={(e) => {
                            setFieldValue('subjectName', e.target.value);
                        }}
                        label='Subject Name'
                        onBlur={handleBlur}
                    />
                </div>
             
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default SubjectForm;